// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2360":"e6d4e1d32f9da4aff96d","2419":"13714a008e68e22bb8f2"}[chunkId] + ".css";
};